var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"collection"},[_c('div',[_c('router-link',{attrs:{"to":"/season/3/1"}},[_vm._v("SEASON III / "),_c('strong',[_vm._v("ASPECTS")])])],1)]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"logo-div"},[_c('img',{staticClass:"home-logo",attrs:{"alt":"aprmay.co","src":require("../assets/logo.svg")}})])])
}]

export { render, staticRenderFns }